"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _Checker = require("Reagan/components/Checker");

var _LeadFlowEditor = _interopRequireDefault(require("lead-flows-ui/components/editor/LeadFlowEditor"));

var _LeadFlowByGuidGetter = _interopRequireDefault(require("lead-flows-ui/components/dashboard/LeadFlowByGuidGetter"));

var _GatesUtils = require("lead-flows-ui/utils/GatesUtils");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

var ReaganLeadFlowEditor = (0, _Checker.checker)({
  selectors: {
    success: {
      'lead-flows-editor': '.dyno-editor__editor-panel, .dyno-editor-follow-up-panel, .dyno-editor-options-panel, .dyno-editor-publish'
    },
    error: {
      'lead-flows-editor-load-error': '#lead-flows-app .error-message, #editor-unknown-step'
    }
  }
})(_LeadFlowEditor.default);

var LeadFlowsRouter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(LeadFlowsRouter, _PureComponent);

  function LeadFlowsRouter() {
    (0, _classCallCheck2.default)(this, LeadFlowsRouter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LeadFlowsRouter).apply(this, arguments));
  }

  (0, _createClass2.default)(LeadFlowsRouter, [{
    key: "createScreenChanger",
    value: function createScreenChanger(screenName) {
      return function () {
        (0, _eventsTrackerUtils.trackPageView)({
          screen: screenName
        });
      };
    }
  }, {
    key: "createEditScreenChanger",
    value: function createEditScreenChanger(screenName) {
      var _this = this;

      return function (_ref) {
        var params = _ref.params;
        var gates = _this.props.gates; // Send Amplitude an array containing the enabled gates

        var ungatedGates = (0, _GatesUtils.getUngatedGates)(gates);
        (0, _eventsTrackerUtils.trackPageView)({
          gates: ungatedGates,
          screen: screenName,
          subscreen: params.step
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var history = this.props.history;
      return _react.default.createElement(_reactRouter.Router, {
        history: history
      }, _react.default.createElement(_reactRouter.Route, {
        path: "/lead-flows(-beta)/:portalId"
      }, _react.default.createElement(_reactRouter.Route, {
        path: "from-form-guid/:formGuid",
        component: function component(_ref2) {
          var params = _ref2.params,
              rest = (0, _objectWithoutProperties2.default)(_ref2, ["params"]);
          return _react.default.createElement(_LeadFlowByGuidGetter.default, (0, _extends2.default)({}, rest, params, {
            params: params
          }));
        }
      }), _react.default.createElement(_reactRouter.Route, {
        path: "edit/:dynoId(/:step)",
        component: function component(_ref3) {
          var params = _ref3.params,
              rest = (0, _objectWithoutProperties2.default)(_ref3, ["params"]);
          return _react.default.createElement(ReaganLeadFlowEditor, (0, _extends2.default)({}, rest, params, {
            params: params
          }));
        },
        onEnter: this.createEditScreenChanger('lead-flows-editor')
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        history: _react.PropTypes.object.isRequired
      };
    }
  }]);
  return LeadFlowsRouter;
}(_react.PureComponent);

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    gates: state.gates
  };
})(LeadFlowsRouter);

exports.default = _default;
module.exports = exports.default;